module.exports = __webpack_public_path__ + "img/W-S36.54242104.jpg";